import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Create root and render with loading state management
const root = ReactDOM.createRoot(document.getElementById('root')!)

// Show content smoothly after React hydration
React.useEffect = React.useEffect || (() => {});

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Remove loading state after React has mounted
setTimeout(() => {
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.classList.add('loaded');
  }
}, 100); 